import React, { memo } from 'react';
import PropTypes from 'prop-types';
import LoginContainer from '../Components/Login/LoginContainer';

export default memo(Login);
function Login(props) {
  return <LoginContainer {...props} />;
}

Login.propTypes = { handleLoginSuccess: PropTypes.func };
